<template>
  <div class=" flex-1 flex justify-start pt-10 px-3 overflow-hidden">
    <div class="w-full max-w-lg">
      <h2 class="text-left text-2xl sm:text-3xl font-bold text-gray-800 mb-6">
        Stock Controller
      </h2>
      <div class="flex items-start mb-6">
        <app-button to="/stocktake-app" icon="fa-circle-left" size="small"> Back </app-button>
      </div>
      <div class="flex justify-between pt-3 ">

        <form class="flex flex-col gap-5" @submit.prevent="submit">

          <!-- DEPOT -->
          <div>
            <label class="block text-left text-lg font-semibold text-gray-800 mb-2"> Depot </label>

            <app-dropdown
:model-value="selectedDepot.name" align="right" label-key="name" value-key="name" size="large"
              :options="depots" @update:model-value="(value: string) => store.setSelectedDepot(value)">
              All Depots
            </app-dropdown>

          </div>
          <div>
            <p class="text-red-600 font-semibold text-xl mt-1">Important! The following options must be used once stock
              has been fixed
              on Insphire.
            </p>
          </div>

          <div class="flex flex-col justify-start  pt-20">
            <h2 class="text-left text-2xl sm:text-3xl font-bold text-gray-800 mb-6">
              New Stock Count
            </h2>

            <p class="text-left text-lg  text-gray-1000 mb-6 pb-10">
              Click 'Clear & Fix All Stock' to <b>clear ALL completed stock counts</b> for the selected depot and create
              a new stock count with the fixed items in insphire.
            </p>


            <button
v-if="canUserFixStock()" type="button" class="w-50 py-2 rounded-md text-lg font-semibold transition bg-green-600 text-white"
              @click="callfixStock(selectedDepot.prefix, 'clear')">
              Clear & Fix All Stock
            </button>

          </div>

          <div class="flex flex-col justify-start pt-20">

            <h2 class="text-left text-2xl sm:text-3xl font-bold text-gray-800 mb-6">
              Re-Fix existing Stock Count Items
            </h2>

            <p class="text-left text-lg text-gray-1000 mb-6 pb-10">
              Click 'Re-fix Stock Items' to clear and refix individual items during an existing stock count for the
              selected depot. This will re-fix only the items that you have cleared and re-fix in insphire,whilst
              leaving existing count items active.
            </p>

            <button
v-if="canUserFixStock()" type="button" class="w-520 py-2 rounded-md text-lg font-semibold transition bg-green-600 text-white"
              @click="callfixStock(selectedDepot.prefix, 'refix')">
              Re-fix Stock items
            </button>

          </div>
        </form>
      </div>


    </div>
  </div>
</template>


<script setup lang="ts">
import useStockTake from '@/stores/stocktakestore'
import { useRouter } from 'vue-router'
import useUserStore from '@/stores/auth'
import useToasterStore from '@/stores/toaster'
import AppDropdown from '@/components/base/AppDropdown.vue'
import StockTakeService from '@/services/stocktake'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'


const store = useStockTake()
const router = useRouter()
const userStore = useUserStore()


// expose state as refs for v-model
const {

  selectedDepot,
  depots,
} = storeToRefs(store)

const canUserFixStock = () => {
  return userStore.isAbleTo(['view-stock-controller'])
}

// const canUserFixStock = () => {
//   return userStore.isAbleTo(['edit-stock-id'])
// }

// Reset selected depot when page loads

const callfixStock = async (depotPrefix: string, type: string) => {
  const toaster = useToasterStore()

  try {
    toaster.working({ text: 'Importing stock data...' })

    const api = new StockTakeService()
    await api.importStockItems(depotPrefix, type)

    toaster.clear()
    toaster.success({ text: 'Stock data imported successfully!' })
  } catch (err: any) {
    toaster.clear()
    console.error('Import failed:', err)
    const message = err?.response?.data?.message || err?.message || 'Failed to import stock data'
    toaster.error({ text: message })
  }
}


async function submit() {
  const ok = store.attemptSubmit()
  if (!ok) return



  await router.push(`/stocktake-app/stockitems`)
}

onMounted(() => {
  store.loadDepots()
})

</script>
